import React from "react";
import { isMobile } from "react-device-detect";
import { Trans } from "react-i18next";

import { ACTCODE_TITLE } from "constant/log";
import { TITLE } from "constant/search";

import PrintDate from "components/boards/common/PrintDate";
import Highlight from "components/Highlight";
import PlaylistLink from "components/boards/playlist/PlaylistLink";

/*
* 플레이 리스트 VOD 전체 노출
* */

const PlaylistVodsInfo = ({ playlistUser, inflowPath, playlistPathType }) => {
	const { playlist = {} } = playlistUser;
	const { bbsTitle = {} , count = {}, ucc = {} } = playlist;


	return (
		<div className="vod-info">
			{isMobile && (
				<>
					{/* 닉네임 */}
					<div className="nick">{bbsTitle.user_nick}</div>

					{/* 제목 영역 */}
					<p className="title">{bbsTitle.title_name}</p>

					{/* 정보 영역 */}
					<div className="info">
						<span className="views">{count.read_cnt}</span>
						{playlist.update_date &&
							<PrintDate tag="span" attributes={{ className: "date" }} target={playlist.update_date} />}

					</div>
				</>
			)}

			{!isMobile && (
				<>
					{/* 제목 영역 */}
					<p className="title">
						<PlaylistLink playlist={playlistUser} inflowPaths={inflowPath} >
							<Highlight type={TITLE} __html={playlistUser.title} />
						</PlaylistLink>
					</p>

					{/* 영상 정보 영역 */}
					<div className="info">

						{/* 재생목록 업데이트 날짜 */}
						<em className="update">

							<Trans>업데이트</Trans> {` `}
							<PrintDate target={playlistUser.update_date} />
						</em>
					</div>
				</>
			)}
		</div>
	);
};

export default PlaylistVodsInfo;
